import { alpha, useTheme } from "@mui/material/styles";
import { getFontSize } from "../../themes";
import { EFontSizes, EFontWeights } from "../../themes/types";
export var FieldStyles = function () {
    var theme = useTheme();
    return {
        content: {
            infoBtn: {
                cursor: "pointer",
                color: theme.palette.success.main,
            },
            fieldLabel: {
                color: theme.palette.text.secondary,
                fontSize: getFontSize(EFontSizes.ExtraSmall),
                fontWeight: EFontWeights.Regular,
            },
            helperText: {
                color: alpha(theme.palette.text.primary, 0.38),
                fontSize: getFontSize(EFontSizes.ExtraSmall),
                fontWeight: EFontWeights.Regular,
            },
            errorText: {
                color: theme.palette.error.dark,
                fontSize: getFontSize(EFontSizes.ExtraSmall),
                fontWeight: EFontWeights.Regular,
            },
        },
    };
};
